import Vue from 'vue'
import VueRouter from 'vue-router'

import Form from '../views/Form.vue'
import Done from '../views/Done.vue'
import Commerce from '../views/Commerce.vue'

import OssExplain from '../components/commerce/oss_explain/BackGround.vue'
import Overview from '../components/commerce/overview/Main.vue'
import MngRegister from '../components/commerce/detail/MngRegister'
import Goods from '../components/commerce/detail/Goods'
import IssueToken from '../components/commerce/detail/IssueToken'
import Buy from '../components/commerce/detail/Buy'
import P2p from '../components/commerce/detail/P2p'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Default',
    redirect: '/commerce'
  },
  {
    path: '/form',
    name: 'Form',
    component: Form
  },
  {
    path: '/done',
    name: 'Done',
    component: Done
  },
  {
    path: '/commerce',
    component: Commerce,
    children: [
      {
        path: '/commerce',
        name: 'OssExplain',
        component: OssExplain
      },
      {
        path: '/commerce/overview',
        name: 'Overview',
        component: Overview,
      },
      {
        path: '/commerce/manager/register',
        name: 'MngRegister',
        component: MngRegister,
      },
      {
        path: '/commerce/manager/goods',
        name: 'Goods',
        component: Goods,
      },
      {
        path: '/commerce/manager/token',
        name: 'Token',
        component: IssueToken,
      },
      {
        path: '/commerce/user/buy',
        name: 'Buy',
        component: Buy
      },
      {
        path: '/commerce/user/p2p',
        name: 'P2p',
        component: P2p,
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition){
    if (savedPosition) {
      return savedPosition;
    } else if(to.query.section !== undefined){
      return;
    } else {
      return { x: 0, y: 0 };
    }
  }
})

export default router